import { render, staticRenderFns } from "./ApprovalForm.vue?vue&type=template&id=09a129c6&"
import script from "./ApprovalForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports